import { render, staticRenderFns } from "./BreadcrumbContainer.vue?vue&type=template&id=b3de1c74&scoped=true&"
import script from "./BreadcrumbContainer.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbContainer.vue?vue&type=script&lang=ts&"
import style0 from "./BreadcrumbContainer.vue?vue&type=style&index=0&id=b3de1c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3de1c74",
  null
  
)

export default component.exports